import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, HashRouter } from "react-router-dom";
import "nprogress/nprogress.css";
import App from "src/App";
import { WidgetProvider } from "src/contexts/WidgetContext";
import * as serviceWorker from "src/serviceWorker";
import "./index.css";
import { Auth0Provider as Auth0ProviderWithRedirectCallback } from "@auth0/auth0-react";
import { callbackUri } from "./auth.config";
import "./services/firebase";
import "hammerjs"; // <-- This stays for the zoom plugin gestures
import { isMobileWebBrowser, isChromeIOS, mobile } from "src/utils/platformUtils";
import { loadFrontRuntimeConfig } from "src/services/runtimeFrontConfig";
import { isVegaLipSyncEnabled } from "src/lipsync/vegaLipSync";
import { installAccountDeletedInterceptor } from "src/utils/installAccountDeletedInterceptor";

// Any 401 from our backend → account-deleted event → ProtectedRoute logout
installAccountDeletedInterceptor();

// Hide prerender SEO block once JS runs (crawlers without JS still see it).
document.getElementById("seo-static-content")?.remove();

const widget_divs = document.querySelectorAll(".caas_widget");

//if the user is on mobile web or not mobile (not ios/android), add the class is-mobile-web to the body
if (isMobileWebBrowser() || !mobile) {
  document.body.classList.add("is-mobile-web");
}

// Chrome iOS: viewport-fit=cover inconsistently extends content under the status bar.
// Switch to viewport-fit=auto so Chrome handles the status bar normally (Safari/Capacitor unaffected).
if (isChromeIOS()) {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    viewport.setAttribute("content", viewport.getAttribute("content")!.replace("viewport-fit=cover", "viewport-fit=auto"));
  }
}

// console.log("this is the url callback", callbackUri);

console.log("Auth0 Domain:", process.env.REACT_APP_AUTH0_DOMAIN);
console.log("Callback URI:", callbackUri);

// Smoke-test: allowlisted front tunables from Lombard Mongo (via Chat API /runtime-env/front-config). Admin → Refresh Front cache (Nest) → reload to pick up changes.
(async () => {
  if (!process.env.REACT_APP_BACKEND_URL) return;
  try {
    await loadFrontRuntimeConfig();
    console.log("[RuntimeEnv] front-config merged in SPA (Mongo-backed allowlist via Chat API)");
    isVegaLipSyncEnabled();
  } catch {
    // non-fatal
  }
})();

widget_divs.forEach((widget) => {
  ReactDOM.createRoot(widget).render(
    <HelmetProvider>
      <Auth0ProviderWithRedirectCallback
        domain={process.env.REACT_APP_AUTH0_DOMAIN}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
        authorizationParams={{
          redirect_uri: callbackUri,
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: "openid profile email offline_access",
          prompt: "login", // this is to force the user to select an account with Google
          screen_hint: "consent", // this is to force the user to consent to the terms and conditions
        }}
        cacheLocation="localstorage"
        useRefreshTokens={true}
      // useRefreshTokensFallback={true}
      >
        <WidgetProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </WidgetProvider>
      </Auth0ProviderWithRedirectCallback>
    </HelmetProvider>
  );
});

serviceWorker.unregister();
